define('services/GeoHeatMap',['plugins/http', 'durandal/app', 'knockout', 'durandal/ol'], function (http, app, ko, ol) {
    return {
        vector:null,
        map: null,
        popupElement:null,
        initMap: function (controlname,data,selRiskArea) {
            var geojsonFormat = new ol.format.GeoJSON();
            
            window.loadFeatures = function (response) {
                vectorSource.addFeatures(geojsonFormat.readFeatures(response));
            };
            
            vector = new ol.layer.Vector({
                //source: vectorSource,
                source: new ol.source.Vector({
                    url: 'http://openlayers.org/en/v3.8.2/examples/data/geojson/countries.geojson',
                    format: new ol.format.GeoJSON(),
                    crossOrigin: ''
                }),
                style: function (feature, resolution) {
                    for (i = 0; i < data.length; i++)
                    {
                        if (feature.get('name') === data[i].CFC_COUNTRY_NAME && selRiskArea === data[i].CFC_RISK_AREA)
                        {
                            feature.set("risk_area", data[i].CFC_RISK_AREA);
                            feature.set("risk_level", data[i].CFC_CALCULATED_RISK);
                            feature.set("risk_region", data[i].CFC_REGION);
                            return [new ol.style.Style({
                                stroke: new ol.style.Stroke({
                                    color: data[i].CFC_RISK_COLOR,
                                    width: 3
                                }),
                                fill: new ol.style.Fill({
                                    color: data[i].CFC_RISK_COLOR
                                })
                            })]
                        }
                    }
                },
                title:'countries'
                
            });
            var raster = new ol.layer.Tile({
                source: new ol.source.BingMaps({
                    imagerySet: 'Aerial',
                    key: 'AqxvrFEFrHSo3dSn6Y7PrkrNiMUG5urbWZj_hUwMDCpcjAtdjfNly5-YJX3JuwwL'
                })
            });
            map = new ol.Map({
                layers: [raster, vector],
                target: controlname,
                view: new ol.View({
                    center: [0, 0],
                    zoom: 2
                })
            });
            popupElement = document.getElementById('mappopup');
            
            var popup = new ol.Overlay({
                element: popupElement,
                positioning: 'bottom-center',
                stopEvent: false
            });
            map.addOverlay(popup);

            // display popup on click
            map.on('click', function (evt) {
                if (popupElement == null) {
                    $("div#mapBody").append("<div id='mappopup'></div>");
                    popupElement = document.getElementById('mappopup');
                    popup = new ol.Overlay({
                        element: popupElement,
                        positioning: 'bottom-center',
                        stopEvent: false
                    });
                    map.addOverlay(popup);
                }
                var feature = map.forEachFeatureAtPixel(evt.pixel,
                    function (feature, layer) {
                        return feature;
                    });
                if (feature) {
                    $(popupElement).popover('destroy');
                    popup.setPosition(evt.coordinate);
                    $(popupElement).popover({
                        'placement': 'top',
                        'html': true,
                        'content': "<b>Country: </b>" + feature.get('name') + "</br><b>Region: </b>" + feature.get('risk_region') + "</br><b>Risk Area: </b>" + feature.get('risk_area') + "</br><b>Risk Level: </b>" + feature.get('risk_level')
                    });
                    $(popupElement).popover('show');
                    var pan = ol.animation.pan({
                        duration: 750,
                        source: /** @type {ol.Coordinate} */ (map.getView().getCenter())
                    });
                    map.beforeRender(pan);
                    map.getView().setCenter(evt.coordinate);
                } else {
                    $(popupElement).popover('destroy');
                }
            });


        },
        setLayer: function (data, selRiskArea) {
            $(popupElement).popover('destroy');
            newVectorStyle = function (feature, resolution) {
                for (i = 0; i < data.length; i++) {
                    if (feature.get('name') === data[i].CFC_COUNTRY_NAME && selRiskArea === data[i].CFC_RISK_AREA) {
                        feature.set("risk_area", data[i].CFC_RISK_AREA);
                        feature.set("risk_level", data[i].CFC_CALCULATED_RISK);
                        feature.set("risk_region", data[i].CFC_REGION);
                        return [new ol.style.Style({
                            stroke: new ol.style.Stroke({
                                color: data[i].CFC_RISK_COLOR,
                                width: 3
                            }),
                            fill: new ol.style.Fill({
                                color: data[i].CFC_RISK_COLOR
                            })
                        })]
                    }
                }
            };
            vector.setStyle(newVectorStyle);
        }
    }
});
